export function normalizeInspectionPhotoUrl(url) {
  if (!url) {
    return ''
  }

  const text = String(url)
  const fileId = extractInspectionPhotoFileId(text)
  if (!fileId) {
    return text
  }

  const origin = window.location && window.location.origin ? window.location.origin : ''
  return `${origin}/callComponent/download/getFile/file?fileId=${encodeURIComponent(fileId)}&communityId=-1`
}

function extractInspectionPhotoFileId(url) {
  if (url.indexOf('img/') === 0) {
    return url
  }

  const hcImagePath = '/hc/img/'
  const hcIndex = url.indexOf(hcImagePath)
  if (hcIndex > -1) {
    return url.substring(hcIndex + '/hc/'.length)
  }

  return ''
}
